import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import * as React from 'react'
import { TAP_ZONE_Z_INDEX } from './InteractiveZone'

type Variant = 'transparent' | 'solid'

interface FadeBackgroundProps {
  variant?: Variant
}

const StyledGroup = styled(Group)`
  position: relative;
  z-index: ${TAP_ZONE_Z_INDEX + 3};
  contain: layout;
  &::before {
    content: '';
    position: absolute;
    top: ${rem(-80)};
    left: ${rem(-20)};
    right: ${rem(-20)};
    bottom: ${rem(-24)};
    pointer-events: none;
    z-index: -1;
  }

  &.transparent::before {
    background: linear-gradient(
      to bottom,
      transparent 0%,
      rgba(54, 58, 69, 0.6) 30%,
      rgba(54, 58, 69, 0.9) 60%
    );
  }

  &.solid::before {
    background: linear-gradient(
      to bottom,
      transparent 0%,
      rgba(54, 58, 69, 0.65) 20%,
      rgb(54, 58, 69) 30%
    );
  }
`

function FadeBackground({ children, variant = 'transparent' }: React.PropsWithChildren<FadeBackgroundProps>) {
  return (
    <StyledGroup direction="vertical" shrink={1} verticalAlign="end" gap={16} className={variant}>
      {children}
    </StyledGroup>
  )
}

export default React.memo(FadeBackground)
